export const ErrorTypes = {
  MEDIA_ERR_ABORTED: 'MEDIA_ERR_ABORTED',
  MEDIA_ERR_DECODE: 'MEDIA_ERR_DECODE',
  MEDIA_ERR_NETWORK: 'MEDIA_ERR_NETWORK',
  MEDIA_ERR_SRC_NOT_SUPPORTED: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
  NETWORK_NO_SOURCE: 'NETWORK_NO_SOURCE',
  ZOOM_REFETCH_ERROR: 'ZOOM_REFETCH_ERROR',
  ZOOM_FETCH_ERROR: 'ZOOM_FETCH_ERROR',
  ZOOM_FETCH_MISSING_REQUIREMENTS: 'ZOOM_FETCH_MISSING_REQUIREMENTS',
  REFRESH_AUTH_ERROR: 'REFRESH_AUTH_ERROR',
  UNKNOWN: 'UNKNOWN'
};
export const RecordingHostError = {
  INSECURE_HOST: 'INSECURE_HOST',
  NO_URL: 'NO_URL',
  ZOOM_RECORDING_NOT_FOUND: 'ZOOM_RECORDING_NOT_FOUND'
};